// extracted by css-extract-rspack-plugin
export default {"scene":"src-shared-components-MainLayout-components-AnimatedWallpaper-LayeredWallpaper-LayeredWallpaper-module__scene-TX_Kn6","coordinateSpace":"src-shared-components-MainLayout-components-AnimatedWallpaper-LayeredWallpaper-LayeredWallpaper-module__coordinateSpace-_6UGDd"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"scene\":\"src-shared-components-MainLayout-components-AnimatedWallpaper-LayeredWallpaper-LayeredWallpaper-module__scene-TX_Kn6\",\"coordinateSpace\":\"src-shared-components-MainLayout-components-AnimatedWallpaper-LayeredWallpaper-LayeredWallpaper-module__coordinateSpace-_6UGDd\"}";
        // 1793874317744
        var cssReload = require("../../../../../../../node_modules/.pnpm/@rspack+core@1.5.8_@swc+helpers@0.5.17/node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  